import React, {useEffect, useState} from "react";
import { NavLink} from "react-router-dom";
import 'react-calendar/dist/Calendar.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {ButtonGroup, Card, CardHeader, CardBody, CardTitle, Row, Col,} from "reactstrap";
import Tooltip from "@mui/joy/Tooltip";
import Cookies from "js-cookie";
import axios from 'axios';
import moment from 'moment-jalali';
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import {Button, Grid, TextField} from "@material-ui/core";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
 
function TablePaginationActions(props) {
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<Box sx={{ flexShrink: 0, ml: 2.5 }}>
			<IconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label="first page"
			>
				{theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
			</IconButton>
			<IconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label="previous page"
			>
				{theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
			</IconButton>
			<IconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page"
			>
				{theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
			</IconButton>
			<IconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page"
			>
				{theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
			</IconButton>
		</Box>
	);
}

TablePaginationActions.propTypes = {
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
};

function Home(props) {

	const [page, setPage] = React.useState(0);
	const [tableHover, setTableHover] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);

	// Avoid a layout jump when reaching the last page with empty rows.
	const emptyRows =
		page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(10);

	const [data, setData] = useState([]);
	const [dateTime, setDateTime] = useState(new Date());

	const englishToPersianNumbers = (input) => {
		if (typeof input !== 'string' && !(input instanceof Date)) {
			console.error('Input must be a string or a Date object');
			return input;
		}

		// Define a mapping of English digits to Persian digits
		const digitMap = {
			'0': '۰',
			'1': '۱',
			'2': '۲',
			'3': '۳',
			'4': '۴',
			'5': '۵',
			'6': '۶',
			'7': '۷',
			'8': '۸',
			'9': '۹',
		};

		// Convert numbers in the input to Persian numbers
		const convertedString = input.toString().replace(/\d/g, (digit) => digitMap[digit] || digit);

		return convertedString;
	};
	const convertToSolarAndPersian = (gregorianDate) => {
		// Convert Gregorian date to Jalali (Solar) date
		if (!gregorianDate) gregorianDate = '2111-11-11'
		const solarDate = moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD');

		// Convert English numbers to Persian numbers
		const persianNumbers = englishToPersianNumbers(solarDate)
		//const persianNumbers = Persian(solarDate.toString()).englishNumber().persianNumber()._str;

		return persianNumbers;
	};

	//for api
	useEffect(() => {
		axios.get('https://back.actelmon.ir/api/doctor/patients/', {
			headers: {
				Authorization: `${Cookies.get('token')}` // Assuming you have a function to get the cookie value
			}
		})
			.then((response) => {
				setData(response.data);
				console.log(response)
			})
			.catch((error) => {
				console.error('Error fetching table data:', error);
			});

	}, []);

	//update table after this
	const handleIconEdit = (id) => {
		Cookies.set('patientID',id);
		window.location.href = '/rtl/patientprofile'
	};

	//delete patient
	const handleIconDelete = (id) => {
		// Send an API request to delete the row with the given ID
		axios.delete(`https://back.actelmon.ir/api/doctor/patient/${id}/`, {
			headers: {
				Authorization: `${Cookies.get('token')}`
			}
		})
			.then((response) => {
				// Handle success, if needed
				console.log('Successfully deleted:', response.data);

				// Remove the deleted item from the Data variable
				const deletedItemId = response.data.id;
				const updatedData = data.filter(item => item.id !== deletedItemId);
				setData(updatedData);
				window.location.href = '/rtl/dashboard'
			})
			.catch((error) => {
				console.error('Error deleting data:', error);
				window.location.href = '/rtl/dashboard'
			});
	};

	const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
	const [searchTerm, setSearchTerm] = useState('');

	const handleSort = (key) => {
		let direction = 'asc';
		if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
			direction = 'desc';
		}
		setSortConfig({ key, direction });
	};

	const filteredData = data.filter((item) => {
		const values = Object.values(item).join(' ').toLowerCase();
		console.log(values.includes(searchTerm.toLowerCase()))
		return values.includes(searchTerm.toLowerCase());
	});
	const filteredData1 = data.filter((item) => {
		for (const key in item) {
			if (item[key]/* && item[key].toString().toLowerCase().includes(searchTerm.toLowerCase())*/) {
				return true;
			}
		}
		return false;
	});

	const sortedData = [...filteredData].sort((a, b) => {
		if (sortConfig === null) return 0;
		const keyA = a[sortConfig.key];
		const keyB = b[sortConfig.key];
		if (keyA < keyB) return sortConfig.direction === 'asc' ? -1 : 1;
		if (keyA > keyB) return sortConfig.direction === 'asc' ? 1 : -1;
		return 0;
	});

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	return (
		<>
			<div className="content">
				<Row>

					<Col lg="12" sm="12">
						<Card style={{borderRadius: '10px'}}>
							<CardHeader className="text-right">
								<CardTitle tag="h3" style={{marginRight:'4px'}}>لیست بیماران</CardTitle>
							</CardHeader>
							<CardBody style={{direction:'rtl' , textAlign:'right'}}>

								<Grid container spacing={1} style={{direction:'rtl', textAlign:'right',alignItems:'center'}}>
									<Grid item xs={12} lg={2}>
										<NavLink
											to={'/rtl/addpatient'}
											className="nav-link"
											style={{width:'fit-content'}}
										>
											<Button variant="contained"
											        style={{backgroundColor:'#138C97',color:'white',marginRight:'-14px'}}
											        startIcon={<ControlPointIcon sx={{marginLeft:'10px', color:'white', marginRight:'-10px'}} />}
											>
												افزودن بیمار جدید
											</Button>
										</NavLink>
									</Grid>

									<Grid item xs={12} lg={10}>
										<TextField id="outlined-basic"
										           variant="outlined"
										           fullWidth
										           size={'small'}
										           InputProps={{
											           endAdornment: (
												           <InputAdornment position="end">
													           <SearchIcon color={'#000000'} />
												           </InputAdornment>
											           ),
										           }}
										           value={searchTerm}
										           onChange={handleSearch}
										           style={{backgroundColor:'#eaeaea',borderRadius:'2px'}}
										           placeholder="جستجو بر اساس شماره، نام و نام خانوادگی، نوع آسیب ...."
										           // onChange={(event) => {setSearchTerm(event.target.value)}}
										/>
									</Grid>

									<Grid item xs={12}>
										<TableContainer component={Paper} sx={{direction:'rtl'}}>
											<Table sx={{ minWidth: 650 }} aria-label="simple table">
												<TableHead>
													<TableRow sx={{fontWeight:'bold',backgroundColor:'#F6DDE2'}}>

														<TableCell sx={{fontWeight:'bold'}} align="center" >
															کد شناسایی
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('id')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">
															نام
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('name')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">
															نام خانوادگی
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('last_name')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">
															تاریخ اولین مراجعه
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('firstVisitDate')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">
															تاریخ آخرین ویزیت
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('lastVisitDate')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">
															نوع آسیب
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('injury_type')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">
															بیمه
															<IconButton aria-label="edit" size="large" onClick={() => {
																handleSort('insurance_company')
															}}>
																<SwapVertIcon fontSize="inherit" style={{ color: 'gray', padding: '3px' }} />
															</IconButton>
														</TableCell>

														<TableCell sx={{fontWeight:'bold'}} align="center">عملیات</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{sortedData.map((item) => (
														<TableRow hover
														          key={item.name}
														          sx={{ '&:last-child td, &:last-child th': { border: 0 }  }}
														>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>
																{englishToPersianNumbers(item.id ? item.id.toString() : '0')}
															</TableCell>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>{item.name}</TableCell>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>{item.last_name}</TableCell>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>
																{
																	convertToSolarAndPersian(item.firstVisitDate ?
																		item.firstVisitDate.split('T')[0]:'0000-00-00')
																}
															</TableCell>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>
																{
																	convertToSolarAndPersian(item.lastVisitDate ?
																		item.lastVisitDate.split('T')[0]:'0000-00-00')
																}
															</TableCell>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>{item.injury_type}</TableCell>
															<TableCell align="center" onClick={() => handleIconEdit(item.id)}>{item.insurance_company}</TableCell>
															<TableCell align="center">
																<div>
																		<Tooltip title="ویرایش" variant="soft" arrow>
																			<IconButton aria-label="edit" size="small" onClick={() => handleIconEdit(item.id)}>
																				<BorderColorIcon fontSize="inherit" style={{ color: 'green' }} />
																			</IconButton>
																		</Tooltip>
																		<Tooltip title="حذف" variant="soft" arrow>
																			<IconButton aria-label="edit" size="small" onClick={() => handleIconDelete(item.id)}>
																				<DeleteForeverIcon fontSize="inherit" style={{ color: 'red' }} />
																			</IconButton>
																		</Tooltip>
																</div>
															</TableCell>
														</TableRow>
													))}
												</TableBody>
											</Table>
										</TableContainer>
									</Grid>

								</Grid>
							</CardBody>
						</Card>
					</Col>
				</Row>

			</div>
		</>
	);
}

export default Home;
